import { ButtonBaseProps } from '@material-ui/core';
import { ComponentsProps } from '@material-ui/core/styles/props';

const MuiButtonBase: ButtonBaseProps = {
  disableRipple: true,
};

const props: ComponentsProps = {
  MuiButtonBase,
};

export default props;
